import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";


export default function useGetAllReturnWorkflows(shopId: string) {
  return $api.useQuery("get", "/shops/{shopId}/return-workflows", {
    params: { path: { shopId } },
  });
}


export function useGetAllReturnWorkflowsSuspense(shopId: string) {
  return $api.useSuspenseQuery("get", "/shops/{shopId}/return-workflows", {
    params: { path: { shopId } },
  });
}

export const invalidateAllReturnWorkflowsKey = (shopId: string) => [
  "get",
  "/shops/{shopId}/return-workflows",
  { params: { path: { shopId } } },
];

export function useInvalidateAllReturnWorkflows() {
  const client = useQueryClient();
  return (shopId: string) => {
    client.invalidateQueries({
      queryKey: invalidateAllReturnWorkflowsKey(shopId),
    });
  };
}
